import styled from 'styled-components'

export const Card = styled.div`
	padding: 25px;
	border-radius: 5px;
	border: ${props => `1px solid ${props.theme.border}`};
`
